import Client from '@/repositories/Clients/AxiosClient';
import Config from '@/repositories/Clients/AxiosDefaultConfig';
import { prepareSearchParams } from '@/libs/helper';

const resource = `${Config.basePath}/v1/api/admin/report`;

export default {
  index(payload) {
    let params = prepareSearchParams(payload);
    params = {
      ...payload,
      ...params,
      username: payload.search,
    }
    return Client.post(resource, params, {
      headers: {
        action: "parley-report",
      },
    });
  },
  total(payload) {
    let params = prepareSearchParams(payload);
    params = {
      ...payload,
      ...params,
      username: payload.search,
    }
    return Client.post(resource, params, {
      headers: {
        action: "parley-report-total",
      },
    });
  },
  listParleyHistory(payload) {
    let params = prepareSearchParams(payload);
    params = {
      ...payload,
      ...params,
      username: payload.search,
    }
    params.filters.push({
      searchby: "bet_type",
      searchoperator: "=",
      search: "parley",
    });
    if (payload.parleyResult) {
      params.filters.push({
        searchby: "parley_result",
        searchoperator: "!=",
        search: null,
      });
    } else {
      params.filters.push({
        searchby: "parley_result",
        searchoperator: "=",
        search: null,
      });
    }
    if (payload.startDate) {
      params.filters.push({
        searchby: "created_at",
        searchoperator: ">",
        search: `${payload.startDate} 00:00:00`,
      });
    }
    if (payload.toDate) {
      params.filters.push({
        searchby: "created_at",
        searchoperator: "<",
        search: `${payload.toDate} 23:59:59`,
      });
    }
    return Client.post(`${resource}`, params, {
      headers: {
        action: "list-bet-history",
      },
    });
  },
  totalParleyHistory(payload) {
    let params = prepareSearchParams(payload);
    params = {
      ...payload,
      ...params,
      username: payload.search,
    }
    params.filters.push({
      searchby: "bet_type",
      searchoperator: "=",
      search: "parley",
    });
    if (payload.parleyResult) {
      params.filters.push({
        searchby: "parley_result",
        searchoperator: "!=",
        search: null,
      });
    } else {
      params.filters.push({
        searchby: "parley_result",
        searchoperator: "=",
        search: null,
      });
    }
    if (payload.startDate) {
      params.filters.push({
        searchby: "created_at",
        searchoperator: ">",
        search: `${payload.startDate} 00:00:00`,
      });
    }
    if (payload.toDate) {
      params.filters.push({
        searchby: "created_at",
        searchoperator: "<",
        search: `${payload.toDate} 23:59:59`,
      });
    }
    return Client.post(`${resource}`, params, {
      headers: {
        action: "list-bet-history-total",
      },
    });
  },
};
